import RouteProvider from './router/router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800, 
      once: true,
      mirror: false,
      offset: 100, 
      easing: 'ease-out-cubic', 
    });

    AOS.refresh();
  }, []);
  const root = getComputedStyle(document.documentElement);
  const font = root.getPropertyValue('PRODUCT_DESCRIPTION').trim();

  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 5000,
          style: {
            background: 'var(--primary-color)',
            color: 'var(--main-heading)',
            fontSize: '16px',
            fontFamily: font,
            padding: '14px 20px',
            borderRadius: '8px',
            textAlign: 'center'
          },
        }}
      />
      <RouteProvider />
    </>
  );
};

export default App;
